import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import SwiperNavigation from "@components/ProductSwiper";
import { RadarChart } from "@components/Spider/RadarChart";
// import { useInsightsStore } from "src/store/insights/insights.state";
// import { setRadarData } from "src/utils/setRadarData";
// import DynamicComparisonBlock from "@pages/CROModule/components/CROPage/components/Sections/AspectOptimisation/ComparisonBlock";
import { StatsType, ReviewType } from "./types";
import DynamicComparisonBlock from "@pages/Compare/components/ProductComparison/ComparisonBlock";

export const AspectOptimization = ({
  isWhatIf,
  AspectsStats,
  AspectsReviews,
}: {
  isWhatIf: boolean;
  AspectsStats: StatsType[];
  AspectsReviews: ReviewType[];
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentAspectData, setCurrentAspectData] = useState<StatsType | null>(
    null,
  );
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  useEffect(() => {
    if (AspectsStats && AspectsStats.length > 0) {
      setCurrentAspectData(AspectsStats[activeIndex]);
    }
  }, [activeIndex, AspectsStats]);

  const radarData = AspectsStats.map((aspect) => ({
    label: aspect.aspect,
    value: aspect.bayesian_avg.toFixed(1),
  }));

  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex < AspectsStats.length - 1 ? prevIndex + 1 : 0,
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : AspectsStats.length - 1,
    );
  };

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
    if (isTooltipVisible) {
      setIsTooltipVisible(false);
    }
  };

  // const handleReset = () => {
  //   setCurrentDataSet(setRadarData(productOne.spiderValues));
  //   setIsNewData(false);
  //   setActiveIndex(0);
  // };

  // const improvementValue = (0.2 + activeIndex * 0.1).toFixed(1);
  // const singleDataSet = [currentDataSet[0]];

  const currentReview = AspectsReviews?.find(
    (_review, index) => index === activeIndex,
  );

  return (
    <div className={styles.container}>
      <div className={styles.radarBox}>
        <RadarChart
          datasets={[
            {
              label: "Current Aspect",
              data: radarData.map((item) => item.value),
              borderColor: "#5295E0",
            },
          ]}
          activeIndex={activeIndex}
          onDotClick={handleDotClick}
          isDragEnabled={true}
          showTooltipWithArrow={isTooltipVisible}
          blockChanging={false}
          width={460}
          height={420}
          labelFontSize={11}
          suggestedMax={10}
          productOneTitles={radarData.map((item) => item.label)}
          productOneValues={radarData.map((item) => parseFloat(item.value))}
          productTwoValues={[]}
        />
      </div>
      {/* {!hideStats && ( */}
      <div className={styles.headContent}>
        <div className={styles.comparation}>
          {isWhatIf && (
            <SwiperNavigation
              headerText={currentAspectData?.aspect || ""}
              onNext={handleNext}
              onPrev={handlePrev}
              showText={true}
              improvementValue={currentReview?.score.toFixed(1) || "0.0"}
              currentReview={currentReview}
            />
          )}
          {/* <DynamicComparisonBlock
              productScore={yourSet?.data[activeIndex] ?? 0}
              competitorScore={competitorsSet?.data[activeIndex] ?? 0}
              competitorsCount={product.length}
            /> */}
        </div>
      </div>
      {/* )} */}
    </div>
  );
};
